/* 🤖 this file was generated by script */
export const wiconStatusDonut = {
  name: 'status_donut',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-width="1.5" d="M13.5 10a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z" clip-rule="evenodd"/></svg>`,
};
